import {IElement, ITextAttributes, ITextSelectionInformation} from 'routes/private/Editor/types';
import { execCommandToSelectedText, updateRenderingTextSegments } from 'utils/textMultiStyling'

export const fontItalicResolver = ( element: IElement, value: boolean, textSelectionInformation?: ITextSelectionInformation ):IElement => {
    if (element.type === "Text") {
        const attributes = execCommandToSelectedText("fontItalic", (element.attributes as ITextAttributes), textSelectionInformation, value);
        element.attributes = updateRenderingTextSegments(attributes);
    }
    return element;
}